import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { useBouyguesStore } from '~/scopes/checkout/stores/bouyguesStore'

import { CHECKOUT } from '../../routes-names'
import { hasSelectedOnlineMobilePlan } from '../../utils/hasSelectedMobilePlan'

export function useRedirectBouyguesMobilePlan() {
  const bouyguesStore = useBouyguesStore()

  const redirectBouyguesMobilePlan = async (
    items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
  ) => {
    const hasBouyguesAuthToken = !isEmpty(bouyguesStore.accessToken)
    const hasBouyguesPhonelineInfo = !isEmpty(
      bouyguesStore.phonelineSetupInformation,
    )
    const hasCompleteBouyguesFlow =
      hasBouyguesAuthToken && hasBouyguesPhonelineInfo

    const hasBouyguesMobilePlan = hasSelectedOnlineMobilePlan(items)

    if (hasBouyguesMobilePlan && !hasCompleteBouyguesFlow) {
      await navigateTo({
        name: !hasBouyguesAuthToken
          ? CHECKOUT.SERVICES.BOUYGUES.SIGN_UP
          : CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP,
      })
    }
  }

  return { redirectBouyguesMobilePlan }
}
